import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm, change } from 'redux-form'

import { showTooltip, hideTooltip } from '../../actions/actions.export.js'
import './CustomField.css';

var fieldTimeout;

class CustomField extends Component {
  constructor(props){
    super(props);

    this.state = {
      name: props.name,
      value: props.value || '',
      serverErrors: props.serverErrors,
      changeCounter: 0,
      blurCounter: 0,
      focusCounter: 0,
      showPassword: false,
      autoCompleteList: props.autoCompleteList
    }

    this.handleFocus = this.handleFocus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.togglePasswordShow = this.togglePasswordShow.bind(this);
    this.checkClientValidation = this.checkClientValidation.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.throwTooltipError = this.throwTooltipError.bind(this);
    this.hideTooltipError = this.hideTooltipError.bind(this);
    this.errorCheck = this.errorCheck.bind(this);
    this.getErrorString = this.getErrorString.bind(this);

    this.fieldRef = React.createRef();
    this.getValue = this.getValue.bind(this);
  }

  getValue(){
    return this.state.value;
  }

  handleMouseEnter(e){
    const { dispatch } = this.props;

    if(this.props.disabled) return;
    if(!this.state.touched) return;

    var valid = this.errorCheck(this.state.value, true, false);
  }


  throwTooltipError(err){
    const { dispatch } = this.props;

    if(err && this.props.description && !this.props.errorOverride){
      this.setState({
        showTooltip: true
      })
      dispatch(showTooltip({
        el: document.getElementById('field_' + this.props.name),
        nobr: false,
        position: 'right',
        content: <div style={{maxWidth: 150}} className="text-danger text-center">
          <i className="fas fa-exclamation-triangle"/> &nbsp;{err}
        </div>
      }))
    }
  }

  hideTooltipError(err){
    const { dispatch } = this.props;
    if(this.state.showTooltip){
      dispatch(hideTooltip());
      this.setState({
        showTooltip: false
      })
    }
  }

  handleMouseLeave(){
    const { dispatch } = this.props;

    // if(this.state.showTooltip){
    //   dispatch(hideTooltip());
    //   this.setState({
    //     showTooltip: false
    //   })
    // }
  }

  handleFocus(){
    if(this.props.onTouch){
      this.props.onTouch();
    }
    this.setState({
      touched: true,
      focus: true,
      focusCounter: this.state.focusCounter + 1
    });

    this.errorCheck(this.state.value);
  }

  handleBlur(e){ 

    if(this.props.onBlur){
      this.props.onBlur(e.target.value);
    }
    this.setState({
      focus: false,
      blurCounter: this.state.blurCounter + 1
    });

    setTimeout(()=>{
      let err = this.errorCheck(this.state.value, true);
      this.hideTooltipError();
    }, 10);
  }

  checkClientValidation(value){
    if(this.props.clientValidation){
      var cv = this.props.clientValidation(value);

      this.setState({
        clientError: cv
      });
      return cv;
    }
  }

  errorCheck(value, suppressTooltip, internalChange){
    var clientError = this.checkClientValidation(value);
    
    var err = this.getErrorString(value, internalChange) || clientError;

    if(this.props.validIfBlank && value === ''){
      err = false;
    }

    if(!err || suppressTooltip){
      this.hideTooltipError(err);
      this.setState({
        err: undefined
      })
    }
    
    if(err){
      if(!suppressTooltip) this.throwTooltipError(err);

      this.setState({
        err: err
      })

      return false;
    }


    return true;
  }

  handleChange(e){
    const value = e.target.value;


    let autocomplete = "";

    if(this.state.autoCompleteList && value && value.length > 0){
      this.state.autoCompleteList.sort((a,b)=>{
        if(a < b) return -1;
        if(a > b) return 1;
        return 0;
      })

      autocomplete = this.state.autoCompleteList.find(a => a.indexOf(value) == 0);
    }

    this.setState({
      value: value,
      autocomplete: autocomplete,
      internalChange: true,
      changeCounter: this.state.changeCounter + 1
    });

    var valid = this.errorCheck(value, false, true);

    var el = document.getElementById('field_' + this.props.name);
    if(this.props.multipleRows && el){
      el.style.cssText = 'height:auto;';
      let height = (2 + el.scrollHeight) + 'px';
      el.style.cssText = 'height:' + height + ';';
    }

    if(this.props.onChange){
      if(this.props.timeout){
        clearTimeout(fieldTimeout);
        fieldTimeout = setTimeout((t)=>{
          if(valid){
            this.props.onChange(value);
          } else {
            this.props.onChange('');
          }
        }, this.props.timeout);
      } else {
        if(valid){
          this.props.onChange(value);
        } else {
          this.props.onChange('');
        }
      }
    } 

  }

  componentDidMount(){
    const props = this.props;
    this.setState({
      value: this.fieldRef.current.value
    });

    var el = document.getElementById('field_' + this.props.name);

    if(this.props.multipleRows && el){
      setTimeout(function(){
        if(el){
          el.style.cssText = 'height:auto;';
          var height = (2 + el.scrollHeight) + 'px';
          el.style.cssText = 'height:' + height + ';';
        }
      })
    }
  }

  togglePasswordShow(){
    var ps = this.state.showPassword;
    ps = !ps;
    
    this.setState({
      showPassword: ps
    });
  }

  getErrorString(value, internalChange){ 
    
    if(!this.fieldRef.current) return;
    const { dispatch } = this.props;
    const props = this.props;

    var ic = internalChange || this.state.internalChange;

    if(value === undefined) value = ""; 

    if(this.state.serverErrors && !ic) return this.state.serverErrors;
    
    if(!this.state.touched && value === '' && this.state.changeCounter === 0) return;
    
    if(props.maxLength !== undefined){
      if(value.length > props.maxLength){
        return "Too long: " + value.length + '/' + props.maxLength;
      }
    }

    // check length
    if(props.minLength !== undefined){
      if(value.length < props.minLength){
        return "Must be at least " + props.minLength + " characters.";
      }
    }
    
    if((value == "" || value == undefined) && this.state.blurCounter > 0 && props.required){
      return "Required";
    }

      
    if(this.props.regex && value !== undefined && value !== "" && this.state.blurCounter > 0){
      var r;
      var err = ''
      switch(this.props.regex){
        case 'version':
          r = /^\d{1,2}\.\d{1,2}\.\d{1,2}$/
          err = 'Needs to be X.Y.Z format.'
          break;
        case 'alphanumeric':
          r = /^[a-zA-Z0-9]+$/
          err = 'Alphanumeric characters only.'
          break;
        case 'alphanumeric-hyphen':
          r = /^[a-zA-Z0-9-]+$/
          err = 'Alphanumeric characters and hyphens only.'
          break;
        case 'lowercase-alphanumeric-hyphen':
          r = /^[a-z0-9-]+$/
          err = 'Lowercase alphanumeric characters and hyphens only.'
          break;
        case 'lowercase-alphanumeric-hyphen-underscore':
          r = /^[a-z0-9-_]+$/
          err = 'Lowercase letters, numbers, hyphens, and underscores only.'
          break;
        case 'hexadecimal':
          r = /^#(?:[0-9a-fA-F]{3}){1,2}$/
          err = 'Please enter a valid hexadecimal code, starting with #.';
          break;
        case 'alphanumeric-hyphen-underscore':
          r = /^[a-zA-Z0-9-_]+$/
          err = 'Letters, numbers, hyphens, and underscores only.'
          break;
        case 'alphanumeric-underscore':
          r = /^[a-zA-Z0-9_]+$/
          err = 'Letters, numbers, and underscores only.'
          break;
        case 'email':
          r = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
          err = 'Not a valid email address.'
          break;
        case 'url':
          r = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,}\.[a-z]{2,}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
          err = 'Must be a valid URL.'
          break;
      }
      if(r){
        var re = new RegExp(r);
        if(!re.test(value)){
          return err;
        }
      }
    }


    // no errors at this point so lets hide the tooltip if there is one
    if(this.state.showTooltip){
      dispatch(hideTooltip());
      this.setState({
        showTooltip: false
      })
    }
  }

  handleKeyDown(e){
    const { dispatch } = this.props;

    // console.log(e);
    if(e.key === "Tab"){
      if(this.state.autocomplete){
        e.preventDefault();

        dispatch(change(this.props.formName, this.props.name, this.state.autocomplete));

        this.setState({
          value: this.state.autocomplete,
          autocomplete: ""
        })

        setTimeout(()=>{
          if(this.props.onChange){
            this.props.onChange(this.state.value);
          }
        }, 10);
      }
    }
  }

  render(){
    const err = this.state.err;

    
    return <div className={"field " + ((this.props.inline || this.props.noLabel) ? " no-margin" : "") + ((this.props.hideArrows) ? " hide-arrows" : "")}>
      <div>
        {
          (this.props.inline || this.props.noLabel) ? "" : (
            <span className={"field-label " + (this.getValue() || this.props.label ? "" : "field-label-hidden") + (this.props.disabled ? " translucent" : "") }>
              {(this.props.label || this.props.placeholder || this.props.name) + (this.props.required ? '*' : '')}
            </span>
          )
        }
      </div>
      <div
        className={"position-relative " + (this.props.size && " field-" + this.props.size)}
        onMouseEnter={this.handleMouseEnter} 
        onMouseLeave={this.handleMouseLeave}
        >
        {
          this.props.form === false ? 

            !this.props.multipleRows ? (
              <input 
                ref={this.fieldRef}
                id={'field_' + this.props.name}
                className={"input " + (err || this.state.clientError ? "input-error" : "") + (" input-" + this.props.size) + (this.props.inline ? " input-inline" : "")} 
                type={(this.props.type === 'password' && this.state.showPassword) ? 'text' : this.props.type || 'text'} 
                name={this.props.name}
                value={this.state.value}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
                placeholder={(this.props.placeholder || this.props.name) + (this.props.required && !this.props.label ? ' *' : '')}
                disabled={this.props.disabled} 
                required={this.props.required}
                minLength={this.props.minLength}
                maxLength={this.props.maxLength}
                min={this.props.min}
                max={this.props.max}
                autoFocus={this.props.autoFocus}
                />
            ) : (
              <textarea
                id={'field_' + this.props.name}
                ref={this.fieldRef}
                className={"input " + (err || this.state.clientError ? "input-error" : "") + (" input-" + this.props.size)} 
                name={this.props.name}
                type={this.props.type || 'text'} 
                rows={this.props.minRows || 2}
                value={this.state.value}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
                placeholder={(this.props.placeholder || this.props.name) + (this.props.required && !this.props.label ? ' *' : '')}
                disabled={this.props.disabled} 
                required={this.props.required}
                minLength={this.props.minLength}
                maxLength={this.props.maxLength}
                autoFocus={this.props.autoFocus}
              ></textarea>
            )
          :
          <Field 
            component={this.props.multipleRows ? "textarea" : "input"}
            id={'field_' + this.props.name}
            ref={this.fieldRef}
            className={"input " + (err || this.state.clientError ? "input-error" : "") + (" input-" + this.props.size) + (this.props.inline ? " input-inline" : "")} 
            name={this.props.name}
            type={(this.props.type === 'password' && this.state.showPassword) ? 'text' : this.props.type || 'text'} 
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            rows={this.props.minRows || 2}
            placeholder={(this.props.placeholder || this.props.name) + (this.props.required && !this.props.label ? ' *' : '')}
            disabled={this.props.disabled} 
            required={this.props.required}
            minLength={this.props.minLength}
            maxLength={this.props.hardLimit ? this.props.maxLength : undefined}
            autoFocus={this.props.autoFocus}
            />
        }

        {
          (this.state.autoCompleteList && this.state.autocomplete && this.state.focus) && 
          <div className="field-auto-complete">
            <span className="invisible">{this.state.value}</span>{this.state.autocomplete.replace(this.state.value,"")}
          </div>
        }
       
        {
          this.props.type === 'password' && <span className="field-icon" key={this.state.showPassword} onClick={this.togglePasswordShow}>
            <i className={"fa-lg fa-fw clickable " + (this.state.showPassword ? "fad fa-mask" : "fas fa-mask")}/>
          </span>
        }
        {
          this.props.icon && <span className="field-icon">
            <i className={"far fa-lg fa-fw no-click " + this.props.icon}/>
          </span>
        }
        {
          (err && this.props.inline) && <span className="field-icon-inline" key={this.state.showPassword} onClick={this.togglePasswordShow}>
            <i className="fas fa-lg fa-fw fa-exclamation-circle text-danger"/>
          </span>
        }
      </div>

      {
        !this.props.inline && (
          <div>
            {
              ((err && !this.props.description) || (err && (this.state.serverErrors || this.props.errorOverride))) ? (
                <div className="field-error">
                  <span>{ err }</span>
                </div>
                ) : (
                <div className={"field-description" + (this.props.disabled ? " translucent" : "") }>
                  <span>{ this.props.description }</span>
                </div>
              )
            }
          </div>
        )
      }
    </div>
  }

  componentWillReceiveProps(newprops){

    this.setState({
      autoCompleteList: newprops.autoCompleteList
    })

    if(newprops.value !== this.state.value && newprops.value !== undefined && newprops.value !== "" && !this.state.focus){
      this.handleChange({target: {value: newprops.value}})
    }

    if(newprops.serverErrors !== this.state.serverErrors){
      this.setState({
        lastServerErrors: this.state.serverErrors,
        serverErrors: newprops.serverErrors,
        internalChange: false
      })

      setTimeout((e)=>{
        this.setState({
          err: this.getErrorString(this.state.value)
        })
      })
    }

    if(!this.state.focus){
      if(newprops.form === false || (newprops.validIfBlank && newprops.value === '')){
        this.setState({
          value: newprops.value
        })
      }
    }
  }
}


CustomField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  onTouch: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  error: PropTypes.string
}


const mapStateToProps = (state) => {
  const { 
    
    //...
  } = state;

  return {
    
    //...
  }
}

export default connect(mapStateToProps)(CustomField);



// WEBPACK FOOTER //
// ./src/components/CustomField/CustomField.js